import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBRecurringExport } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (recurringExportId: number) => {
  if (!recurringExportId) {
    throw new Error('`recurringExportId` is required');
  }
};

type RequestParams = {
  recurringExportId: number;
};

type Response = {
  recurring_exports: DBRecurringExport[];
};

export const deleteRecurringExportById = async (
  scope: RequestScope,
  { recurringExportId }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(recurringExportId);

    const result = await scopedApi(scope).delete<EndpointResponse<Response>>(`recurring_export/${recurringExportId}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
